import { render, staticRenderFns } from "./BusinessRxItems.vue?vue&type=template&id=fe7290b0"
import script from "./BusinessRxItems.vue?vue&type=script&lang=js"
export * from "./BusinessRxItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports